import { OpeningHours1Props } from "../../../props";
import styles from "./opening-hours-variant-01.module.scss";
import { ScheduleColumn } from "./schedule-column";

export const OpeningHoursVariant01 = (props: OpeningHours1Props) => {
  const { id, ...scheduleProps } = props;
  const salesSchedule = Object.fromEntries(
    Object.entries(scheduleProps).filter(([key]) => key.startsWith("sales_"))
  );
  const financeSchedule = Object.fromEntries(
    Object.entries(scheduleProps).filter(([key]) => key.startsWith("finance_"))
  );

  return (
    <section className={`${styles.section} section-${id}`}>
      <div className={`${styles.container} container-${id}`}>
        <div className={`${styles["wrapper-header"]} header-container-${id}`}>
          <h1 className={`${styles.title} title-${id}`}>Nossos Horários</h1>
          <p className={`${styles.description} description-${id}`}>
            Confira nossos horários de atendimento
          </p>
        </div>
        <div className={`${styles["content-wrapper"]} content-wrapper-${id}`}>
          <ScheduleColumn title="Vendas" schedule={salesSchedule} id={id} />
          <div className={`${styles.divider} divider-${id}`} />
          <ScheduleColumn
            title="Financeiro"
            schedule={financeSchedule}
            id={id}
          />
        </div>
      </div>
    </section>
  );
};
